import React from 'react';
import { Checkbox } from 'antd';

const CheckboxComponent = ({onChange,checked}) => <Checkbox onChange={onChange}
checked={checked}></Checkbox>;
export default CheckboxComponent;